import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
export const ResetPasswordCheck = ({ children }) => {
    const { dispatch, state } = useGlobalState();
    const navigate = useNavigate();
    const { user, resToken } = state;
    const location = useLocation();
    // if resToken provided during signin, password reset is required
    const resetPassword = !!resToken;
    useEffect(() => {
        if (!resetPassword) {
            return;
        }
        dispatch(setMessages({
            severity: 'warning',
            value: 'Your Password is older than 90 days. Please reset it. Check your email for a reset token.'
        }));
        navigate('/reset-password', { state: { sid: resToken } });
    }, [resetPassword, user?.email, navigate]);
    if (resetPassword && location.pathname !== '/reset-password') {
        return null;
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
};
